module.exports = __webpack_public_path__ + "static/media/404-error.d4951e36.svg";